export default "<div>\n  <ng-template appUploadDialog></ng-template>\n</div>\n";